module.exports = __webpack_public_path__ + "img/Frame 66424.2b49bc1d.png";